import styled, { DefaultTheme } from 'styled-components';
import { FjEditableInput } from 'components/primitives';

interface EditableInputAttrsProps {
  theme: DefaultTheme;
  readOnly?: boolean;
}

const EditableInput = styled(FjEditableInput).attrs(
  ({ theme, readOnly }: EditableInputAttrsProps) => ({
    primaryColor: readOnly ? theme.colors.disabledText : theme.colors.selectableDarkBg,
    singleClick: true,
  }),
)``;

export default EditableInput;
